<template>
    <div class="w-full">
        <div class="w-full md:w-1/2 mx-auto">
            <div class="w-full mt-10">
                <h1
                    class="text-center font-bold tracking-wider text-2xl md:text-3xl font-viga text-secondary mb-5"
                >
                    Antrian Pendaftaran Poliklinik
                </h1>
            </div>
            <div class="w-full text-center">
                <SelectInput
                            v-model="poli"
                            id="poli"
                            label=""
                        >
                            <option value="">=== PILIH POLI ===</option>
                            <option
                                v-for="layanan in layanan"
                                :key="layanan.FS_KD_LAYANAN"
                                :value="layanan.FS_KD_LAYANAN"
                            >
                                {{ layanan.FS_NM_LAYANAN }}
                            </option>
                        </SelectInput>
            </div>
            <div
                v-if="antrianPoli"
                class="w-full flex flex-col justify-center items-center"
            >
            <AntrianPoliCard
                :antrianPoli="antrianPoli"
                :poli="poli"
            />
            </div>
            <div v-if="error" class="w-full h-20 flex items-center bg-red-600 p-2 rounded-lg text-white justify-center mt-2">
                        {{ error }}
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import SelectInput from "../Shared/SelectInput.vue";
import LayoutNoHeader from "../Shared/LayoutNoHeader.vue";
import RandomShape from "../Shared/RandomShape.vue";
import AntrianPoliCard from "../Shared/AntrianPoliCard.vue";
export default {
    data(){
        return {
            poli: '',
            antrianPoli: '',
            error: ''
        }
    },
    methods: {
        getAntrianPoli(){
            this.$inertia.get(
                "/antrian_poli/ajax/"+this.poli,
                {
                },
                {
                    preserveScroll: true,
                    preserveState: true,
                    onSuccess: (page) => {
                        this.antrianPoli = page.props.additional.antrianPoli;
                        if(!this.antrianPoli){
                            this.error = 'Data antrian poli belum tersedia'
                        }else{
                            this.error = '';
                        }
                    },
                }
            );
        }
    },
    components: {
        Link,
        RandomShape,
        SelectInput,
        AntrianPoliCard
    },
    props: {
        layanan: Object,
    },
    layout: LayoutNoHeader,
    watch: {
        poli:{
            handler(value){
                this.antrianPoli = '';
                if(value){
                    this.getAntrianPoli();
                }else{
                    this.antrianPoli = '';
                }
            }
        }
    }
};
</script>
